import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import rostrud from "../../../images/ministrys/Emblem_of_Rostrud.svg.png";

export default function Vacancies() {
  return (
    <section className="vacancies">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Вакансии
      </h1>
      <div>
        <div className="licenses__blank">
          {/* 🔹 Вакансия */}
          <div className="vacancy">
            <h3 className="vacancy__title">
              Медицинская сестра по физиотерапии
            </h3>

            <p className="vacancy__salary">от 80 000 ₽ за месяц, на руки</p>

            <p className="vacancy__info">
              ГБУ СО УРНИИДВИИ <br />
              Ботаническая, Чкаловская, Екатеринбург, ул. Щербакова, 8
            </p>

            <p className="vacancy__info">
              Выплаты: два раза в месяц <br />
              Опыт работы: не требуется <br />
              Полная занятость <br />
              Оформление: Трудовой договор <br />
              График: 5/2 <br />
              Рабочие часы: 7 <br />
              Формат работы: на месте работодателя
            </p>

            <h4 className="vacancy__subtitle">Обязанности:</h4>
            <ul className="vacancy__list">
              <li>Работа с ПК / ноутбуком</li>
              <li>Ведение документации</li>
              <li>Соблюдение санитарных норм (СанПиН)</li>
              <li>Ведение медицинской документации</li>
              <li>Электронный и бумажный документооборот</li>
              <li>Соблюдение асептики и антисептики</li>
              <li>Подготовка кабинета к приему пациентов</li>
              <li>Обеспечение инфекционной безопасности</li>
              <li>Контроль оборудования</li>
              <li>Проведение физиотерапевтических процедур</li>
              <li>Контроль состояния пациента</li>
              <li>Работа с лекарственными средствами</li>
              <li>Выполнение назначений врача</li>
              <li>Медицинские манипуляции</li>
              <li>Соблюдение врачебной этики</li>
              <li>Подготовка оборудования и пациента</li>
            </ul>

            <h4 className="vacancy__subtitle">Требования:</h4>
            <ul className="vacancy__list">
              <li>Аккредитация по физиотерапии</li>
              <li>Наличие медкнижки</li>
            </ul>

            <h4 className="vacancy__subtitle">Контакты:</h4>
            <p className="vacancy__contacts">
              Петрунина Людмила Степановна <br />
              📞{" "}
              <a
                href="tel:+79089282044"
                className="structure__download-link controls__link"
              >
                +7 (908) 928-20-44
              </a>{" "}
              <br />
              📧{" "}
              <a
                href="mailto:petruninaluda@mail.ru"
                className="structure__download-link controls__link"
              >
                petruninaluda@mail.ru
              </a>
            </p>
          </div>

          {/* 🔹 Внешние ссылки */}
          <h4 className="directions__more-title licenses__text">
            <li>Работа России</li>
          </h4>

          <img src={rostrud} alt="Работа России" className="controls__image" />

          <div className="licenses__blank-link">
            <a
              href="https://trudvsem.ru/company/1026605770058"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>

          <h4 className="directions__more-title licenses__text">
            <li>Анкета для увольняющегося сотрудника</li>
          </h4>

          <div className="licenses__blank-link">
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLScOlwXmWqNOAG6PuLc8Dn-F00TJIF5unzS0Q64JB4yPWf67dg/viewform?usp=send_form"
              target="_blank"
              rel="noopener noreferrer"
              className="structure__download-link controls__link"
            >
              🌐 Перейти на сайт
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
